<template>
    <q-btn
        color="primary"
        icon="search"
        :label="label || 'View Details'"
        no-caps
        flat
    />
</template>

<script setup>
defineProps({ label: String })
</script>
